import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { LookerFolder } from 'lumen/models';
import protectedRoute from 'lumen/utils/decorators/protected-route';

// @ts-expect-error: Decorator function return type '{ new (...args: any[]): (Anonymous function)<new (...args: any[]) => ProtectedRoute>.DecoratedClass; prototype: (Anonymous function)<any>.DecoratedClass; } & (new (...args: any[]) => ProtectedRoute)' is not assignable to type 'void | typeof CustomReportingRoute'.
@protectedRoute({ features: ['app.business_intelligence.custom_reporting'] })
export default class MarketCustomReportingRoute extends Route {
  @service declare errorTracking: Services['error-tracking'];
  @service declare store: Services['store'];

  loadFoldersTask = task({ restartable: true }, async () => {
    try {
      const folders = await this.store.query<LookerFolder>('looker-folder', {
        namespace: 'api/v3',
        typeKey: 'custom-reporting/folders',
      });

      return [...folders];
    } catch (error) {
      this.errorTracking.captureException(error);
      return undefined;
    }
  });

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const model = {
      folders: this.loadFoldersTask,
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    model.folders.perform();

    return model;
  }
}
